module.exports = "//static.hsappstatic.net/LoginUI/static-1.12927/img/SUI_desktop.svg"